import OrganizationOwnersInfo from './OrganizationOwnersInfo';

export default OrganizationOwnersInfo;
